import React from 'react';

const safePct = v => { const n = parseFloat(v); return isNaN(n) ? 0 : n; };
const META = 90;

const colorSem = v => v >= META ? '#28a745' : v >= 80 ? '#fd7e14' : '#dc3545';
const labelSem = v => v >= META ? 'Cumple' : v >= 80 ? 'En riesgo' : 'No cumple';

const ResultadoFidelidad = ({ fidelizacion }) => {
  if (!fidelizacion || fidelizacion.length === 0)
    return <p className="text-muted mb-0">No hay datos de retención para el período seleccionado.</p>;

  return (
    <>
      {fidelizacion.map((proyecto, i) => {
        const v = safePct(proyecto.producto_pr);
        const col = colorSem(v);
        const activos_total = parseInt(proyecto.activos || 0) + parseInt(proyecto.culminados || 0);
        const brecha = safePct(proyecto.brecha_pr) || parseFloat((Math.max(0, META - v)).toFixed(1));

        return (
          <div key={i} className={i < fidelizacion.length - 1 ? 'mb-4' : ''}>
            {/* Encabezado del proyecto */}
            <div
              className="d-flex align-items-center justify-content-between p-2 mb-2"
              style={{ backgroundColor: '#f8f9fa', borderRadius: 6, borderLeft: `4px solid ${col}` }}
            >
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{proyecto.nombre_proyecto}</div>
                <small className="text-muted">
                  {proyecto.fecha_inicio} — {proyecto.fecha_fin}
                </small>
              </div>
              <div className="text-right">
                <div style={{ fontWeight: 700, fontSize: 22, color: col }}>{v}%</div>
                <span style={{
                  fontSize: 11, fontWeight: 600, color: col,
                  backgroundColor: `${col}15`, padding: '2px 10px', borderRadius: 20,
                }}>
                  {labelSem(v)}
                </span>
              </div>
            </div>

            {/* Tabla de retención */}
            <div className="table-responsive">
              <table className="table table-bordered mb-0" style={{ fontSize: 13 }}>
                <thead className="thead-light">
                  <tr>
                    <th className="text-center">Matriculados</th>
                    <th className="text-center">Activos + Culminados</th>
                    <th className="text-center">Desertados</th>
                    <th className="text-center">Afiliados</th>
                    <th className="text-center" style={{ width: 150 }}>% Retención</th>
                    <th className="text-center" style={{ width: 110 }}>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center align-middle">
                      <strong>{proyecto.cantidad}</strong>
                      <small className="d-block text-muted" style={{ fontSize: 11 }}>100% (meta)</small>
                    </td>
                    <td className="text-center align-middle">
                      <strong>{activos_total}</strong>
                      <small className="d-block text-muted" style={{ fontSize: 11 }}>
                        {parseInt(proyecto.activos || 0)} activos, {parseInt(proyecto.culminados || 0)} culm.
                      </small>
                    </td>
                    <td className="text-center align-middle text-danger">
                      <strong>{proyecto.desertados}</strong>
                      {brecha > 0 && (
                        <small className="d-block text-muted" style={{ fontSize: 11 }}>Brecha: {brecha}%</small>
                      )}
                    </td>
                    <td className="text-center align-middle">{proyecto.afiliados}</td>
                    <td className="text-center align-middle">
                      <div style={{ fontWeight: 700, fontSize: 20, color: col }}>{v}%</div>
                      <div className="progress mt-1" style={{ height: 5, borderRadius: 3 }}>
                        <div
                          className="progress-bar"
                          style={{ width: `${Math.min(100, v)}%`, backgroundColor: col, borderRadius: 3 }}
                        />
                      </div>
                      <small style={{ color: '#aaa', fontSize: 11 }}>Meta: {META}%</small>
                    </td>
                    <td className="text-center align-middle">
                      <span style={{
                        fontSize: 12, fontWeight: 600, color: col,
                        backgroundColor: `${col}15`, padding: '3px 10px', borderRadius: 20,
                      }}>
                        {labelSem(v)}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ResultadoFidelidad;
